import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TracesStore, LogLevel, ChannelType, TracesPhase, SendTrace } from '@argo/traces';
import { CommonPhase } from '@argo/common';
import { AuthenticationStore } from '@argo/authentication';
import { ConfigStore } from '@argo/config';
import { 
  ScaModuleTitleComponent,
  ScaCardWorkshopComponent,
  ScaAlertComponent,
  ScaBadgeComponent,
  ScaIconComponent,
  ScaTextFieldModule,
  ScaButtonComponent
} from '@argo-dev-components-sca-angular/dev-components-sca';

@Component({
  selector: 'app-traces-test-complete',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ScaModuleTitleComponent,
    ScaCardWorkshopComponent,
    ScaAlertComponent,
    ScaBadgeComponent,
    ScaIconComponent,
    ScaTextFieldModule,
    ScaButtonComponent
  ],
  templateUrl: './traces-test-complete-redesigned.component.html',
  styleUrl: './traces-test-complete-redesigned.component.scss'
})
export class TracesTestCompleteComponent {
  readonly tracesStore = inject(TracesStore);
  readonly authStore = inject(AuthenticationStore);
  readonly configStore = inject(ConfigStore);
  readonly CommonPhase = CommonPhase;
  readonly TracesPhase = TracesPhase;
  readonly LogLevel = LogLevel;
  readonly ChannelType = ChannelType;
  readonly coverage = 100;

  sendResult = '';
  sendResultClass = '';

  traceForm: SendTrace = {
    service: 'test-service',
    operation: 'test-operation',
    message: '',
    exception: '',
    logLevelType: LogLevel.INFO
  };

  sendCustomTrace() {
    this.sendResult = '';
    
    if (!this.authStore.logged()) {
      this.sendResult = '❌ Debes estar autenticado para enviar traces';
      this.sendResultClass = 'error';
      setTimeout(() => this.sendResult = '', 3000);
      return;
    }
    
    this.tracesStore.sendTrace(this.traceForm);
    
    setTimeout(() => {
      if (this.tracesStore.isSent$()) {
        this.sendResult = '✅ Trace enviado correctamente al backend';
        this.sendResultClass = 'success';
      } else if (this.tracesStore.isError$()) {
        this.sendResult = `❌ Error al enviar trace: ${this.tracesStore.error$()}`;
        this.sendResultClass = 'error';
      }
    }, 1000);

    setTimeout(() => this.sendResult = '', 5000);
  }

  sendQuickTrace(level: LogLevel, message: string) {
    if (!this.authStore.logged()) {
      this.sendResult = '❌ Debes estar autenticado';
      this.sendResultClass = 'error';
      setTimeout(() => this.sendResult = '', 3000);
      return;
    }

    this.tracesStore.sendTrace({
      service: 'quick-test',
      operation: 'quick-trace',
      message,
      logLevelType: level
    });

    setTimeout(() => {
      if (this.tracesStore.isSent$()) {
        this.sendResult = `✅ Trace ${level} enviado correctamente`;
        this.sendResultClass = 'success';
      }
    }, 1000);

    setTimeout(() => this.sendResult = '', 5000);
  }
}
